import * as React from 'react';

import {
  EntryRacerScoreAttributeDetail,
  ForecastAttribute,
} from '@/lib/apollo/types/gen/graphql';

import HighlightValue from '../Partials/HighlightValue';
import TableData from '../Partials/TableData';
import { BorderData } from './style';

interface RacerScoreDetailDataProps {
  forecast?: ForecastAttribute;
  scoreByAttribute?: EntryRacerScoreAttributeDetail;
  winningAverageScores: number[];
  top2RatioScores: number[];
  top3RatioScores: number[];
}

const RacerScoreDetailData: React.FC<RacerScoreDetailDataProps> = ({
  forecast,
  scoreByAttribute,
  winningAverageScores,
  top2RatioScores,
  top3RatioScores,
}) => {
  const getForecastName = (input?: ForecastAttribute) => {
    switch (input) {
      case ForecastAttribute.First: {
        return '先頭';
      }
      case ForecastAttribute.Second: {
        return '番手';
      }
      case ForecastAttribute.Third: {
        return '３後';
      }
      case ForecastAttribute.Single: {
        return '単騎';
      }
      default: {
        return '';
      }
    }
  };
  return (
    <>
      <TableData>{getForecastName(forecast)}</TableData>
      <TableData>
        {scoreByAttribute && (
          <HighlightValue numArray={winningAverageScores} fractionDigits={1}>
            {scoreByAttribute.winningAverage}
          </HighlightValue>
        )}
      </TableData>
      <TableData>
        {scoreByAttribute && (
          <HighlightValue numArray={top2RatioScores} fractionDigits={1}>
            {scoreByAttribute.top2Ratio}
          </HighlightValue>
        )}
      </TableData>
      <BorderData>
        {scoreByAttribute && (
          <HighlightValue numArray={top3RatioScores} fractionDigits={1}>
            {scoreByAttribute.top3Ratio}
          </HighlightValue>
        )}
      </BorderData>
      <TableData>{scoreByAttribute?.topCount}</TableData>
      <TableData>{scoreByAttribute?.rank2Count}</TableData>
      <TableData>{scoreByAttribute?.rank3Count}</TableData>
      <BorderData>{scoreByAttribute?.unplacedCount}</BorderData>
    </>
  );
};

export default RacerScoreDetailData;
